import React from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function PlannerWeek({ phase, completedTasks, onToggle }) {
  const completedCount = phase.tasks.filter((task) => completedTasks.includes(task.id)).length;

  return (
    <article className="border border-[#244A49]/10 bg-white shadow-card">
      <header className="border-b border-[#244A49]/10 p-6 sm:p-8">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <span className="font-michroma text-xs font-bold uppercase tracking-[0.18em] text-[#409FA1]">
            {phase.number} — {phase.eyebrow}
          </span>
          <span className="rounded-full bg-[#409FA1]/10 px-3 py-1 text-xs font-bold text-[#244A49]">
            {completedCount}/{phase.tasks.length} complete
          </span>
        </div>
        <h2 className="mt-5 text-2xl font-bold tracking-tight sm:text-3xl">
          {phase.title}
        </h2>
        <p className="mt-2 font-semibold text-[#409FA1]">{phase.days}</p>
        <p className="mt-4 max-w-2xl leading-7 text-[#244A49]/65">
          {phase.description}
        </p>
      </header>

      <div className="divide-y divide-[#244A49]/10">
        {phase.tasks.map((task) => {
          const isComplete = completedTasks.includes(task.id);

          return (
            <button
              key={task.id}
              type="button"
              aria-pressed={isComplete}
              onClick={() => onToggle(task.id)}
              className="group flex w-full gap-4 p-6 text-left transition hover:bg-[#F7F8F7] sm:p-8"
            >
              <span
                className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition ${
                  isComplete
                    ? 'border-[#2CB5B0] bg-[#2CB5B0] text-white'
                    : 'border-[#244A49]/25 bg-white text-transparent group-hover:border-[#409FA1]'
                }`}
                aria-hidden="true"
              >
                <SafeIcon name="Check" className="h-4 w-4" />
              </span>
              <span>
                <span className={`block font-bold ${isComplete ? 'text-[#244A49]/45 line-through' : 'text-[#101F1F]'}`}>
                  {task.title}
                </span>
                <span className={`mt-2 block text-sm leading-6 ${isComplete ? 'text-[#244A49]/40' : 'text-[#244A49]/65'}`}>
                  {task.detail}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </article>
  );
}